module.exports = __webpack_public_path__ + "img/text.63c9ab85.png";